const DRAFT_KEY = 'support-client:my-request-draft'

export type TicketFormDraft = {
  serviceParent: string
  serviceType: string
  description: string
  devicesAffected: number
  preferredScheduleAt: string
  preferredScheduleUntil: string
  preferredContactAt: string
  contactNumber: string
  contactPerson: string
  email: string
  storeId: string
  storeCode: string
  storeLabel: string
  siteAddress: string
  errorMessage: string
  contactAvailabilityText: string
  workImpact: string
  othersAffected: string
  userScope: string
  appScope: string
  accessType: string
  workPermitNeeded: string
  permitAvailable: string
  permitDuration: string
  partsApproved: string
  closeOnFix: string
  triageExpanded: boolean
}

export function loadTicketFormDraft(): TicketFormDraft | null {
  try {
    const raw = localStorage.getItem(DRAFT_KEY)
    if (!raw) return null
    return JSON.parse(raw) as TicketFormDraft
  } catch {
    return null
  }
}

export function saveTicketFormDraft(draft: TicketFormDraft): void {
  try {
    localStorage.setItem(DRAFT_KEY, JSON.stringify(draft))
  } catch {
    // ignore quota errors
  }
}

export function clearTicketFormDraft(): void {
  localStorage.removeItem(DRAFT_KEY)
}
